// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fFWc","tabsBox":"styles_tabsBox__2Bf54","createButton":"styles_createButton__3hBnW"};